import {
  AfterViewInit,
  Component,
  ElementRef,
  Inject,
  OnDestroy,
  OnInit,
  ViewChild,
} from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import states from '../../../assets/states/states';
import { CrewMemberDAO } from '../../../core/services/dao/crewMemberDAO';
import { CrewMember } from 'anchor-shared/lib/model/entity/crewMember';
import { ConstantMan } from '../../../core/services/constantMan';
import * as intlTelInput from 'intl-tel-input';

@Component({
  selector: 'app-create-crew-member',
  templateUrl: './create-crew-member.component.html',
  styleUrls: ['./create-crew-member.component.scss'],
})
export class CreateCrewMemberComponent
  implements OnInit, OnDestroy, AfterViewInit
{
  @ViewChild('intlTelInput') private _inputElement!: ElementRef;
  private _intlTelInput: any;
  public E164PhoneNumber!: string | null;
  model = {};
  dialog = false;
  states: any[];
  zipPattern = ConstantMan.PATTERNS.ZIP;

  constructor(
    private crewMemberDao: CrewMemberDAO,
    public dialogRef: MatDialogRef<CreateCrewMemberComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
  ) {
    this.states = states;
    this.initModel();
  }

  ngAfterViewInit(): void {
    const intlTelInputInstance = intlTelInput;
    this._intlTelInput = intlTelInputInstance(
      this._inputElement.nativeElement,
      { preferredCountries: ['us', 'mx'] },
    );
  }

  get intlTelInput(): any {
    return this._intlTelInput;
  }

  get internationalPhoneNumber(): string {
    return this.model['phoneNumber'];
  }

  set internationalPhoneNumber(value: string) {
    if (!!value) {
      this._intlTelInput.setNumber(value);
    }
    this.model['phoneNumber'] = value;
    this.i18nizePhoneNumber();
  }

  public i18nizePhoneNumber(): void {
    this.E164PhoneNumber = null;
    if (this._intlTelInput.isValidNumber()) {
      this.E164PhoneNumber = this._intlTelInput.getNumber();
    }
  }

  hasInvalidPhoneNumber(): boolean {
    if (this._intlTelInput && this._intlTelInput.isValidNumber()) {
      return false;
    }
    return true;
  }

  ngOnInit() {}

  initModel() {
    this.model = {
      firstName: '',
      lastName: '',
      email: '',
      phoneNumber: '',
      mailingAddress: '',
      city: '',
      state: '',
      zip: '',
      userId: null,
    };
  }

  save() {
    this.model['phoneNumber'] = this.E164PhoneNumber;
    this.model['fullName'] =
      this.model['firstName'] + ' ' + this.model['lastName'];
    const data = this.model as CrewMember;
    this.dialogRef.close({ crewMember: data });
  }

  cancel() {
    this.dialogRef.close();
  }

  ngOnDestroy(): void {}
}
